@if (resetCode) {
  <div class="container-fluid">
    <div class="row">
      <div class="col">
        <app-password-change
          [Entry]="Entry"
          [resetCode]="resetCode"
          (passwordErrorEvent)="passwordError = $event"
        ></app-password-change>
      </div>
    </div>
    <div class="row row-padding justify-content-center">
      <div class="col-4">
        <button class="btn btn-primary" (click)="resetPassword()">
          Reset password
        </button>
      </div>
    </div>
  </div>
}
